import React from 'react';
import PdfModal from '../../PdfModal/PdfModal';
var MessageDefault = function (_a) {
    var message = _a.message, documents = _a.documents, onOpenPdf = _a.onOpenPdf;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null, message.response),
        (documents === null || documents === void 0 ? void 0 : documents.length) > 0 && React.createElement(PdfModal, { documents: documents, onOpen: onOpenPdf })));
};
export default MessageDefault;
